export const Active = "A"; // wolny
export const Gone = "G"; // przepadł i nic nie kupiono
export const Reserved = "R"; // przepadł i zarezerwowano
export const Paid = "P"; // przepadł i sprzedany
export const Booked = "B"; // aktywny i zarezerwowany
export const Sold = "S"; // aktywny i sprzedany

export const exerciseSaleStatuses = [
  { value: Active, title: "Wolny" },
  { value: Gone, title: "Pozycja niedostępna" },
  { value: Reserved, title: "Zarezerwowana" },
  { value: Paid, title: "Sprzedana" },
  { value: Booked, title: "Zarezerwowana" },
  { value: Sold, title: "Sprzedana" },
];
